/* eslint-disable no-undefined */
import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { setAgentConfigData, setAgentConfig } from '../../actions/getAgentConfig';
import Switch from 'react-bootstrap-switch';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";
import getV2AxiosInstance from '../../utils/v2Axios.js';

const DragHandle = SortableHandle(() => <span className="icon icon-dots-three-vertical" />);

const getIcon = (type) => {
  switch (type) {
    case 'web_phone':
      return 'icon icon-phone'
    case 'telephony':
      return 'icon icon-old-phone'
    case 'calls_in_queue':
      return 'icon icon-funnel'
    case 'incoming_calls':
      return 'icon icon-login'
    case 'outgoing_calls':
      return 'icon icon-log-out'
    case 'agent':
      return 'icon icon-user'
    case 'autodialer':
      return 'icon icon-flow-tree'
      // case 'themepanel' :
      //   return 'icon'
    default:
      return 'icon icon-old-phone'
  }
}

const SortableItem = SortableElement(({ value, translations, selectedLanguage, panelsDisplay, handleSwitch, isWebphoneEnabled }) =>
  <li style={{height: (isWebphoneEnabled && value === 'web_phone' && panelsDisplay && panelsDisplay.web_phone) ? '60px' : ''}}>
    <div className="panel_item row" style={{top: (isWebphoneEnabled && value === 'web_phone' && panelsDisplay && panelsDisplay.web_phone) ? '42%' : ''}}>
      <div className="col-xs-7" style={{ marginTop: '5px' }}>
        {value !== 'web_phone' && <DragHandle />}
        <span className={getIcon(value)} style={{marginLeft: value === 'web_phone' ? '6px' : ''}}/>&nbsp;&nbsp;
       {translations[value !== 'outgoing_calls' ? value : 'outgoingCalls'][selectedLanguage]}
      </div>
      <div className="col-xs-4 text-right">
        <Switch
          bsSize="small"
          value={panelsDisplay[value]}
          onText={translations.yes[selectedLanguage]}
          offText={translations.no[selectedLanguage]}
          onColor="success"
          offColor="danger"
          onChange={(el, state) => handleSwitch(el, state, value)}
          name='test'
        />
      </div>
    </div>
    {/* { isWebphoneEnabled && value === 'web_phone' && panelsDisplay && panelsDisplay.web_phone && <span style={{fontSize: 12, paddingTop: 9, float: 'left', marginLeft: 8, color: 'red'}}>{translations.changeApplyInNextLogin[selectedLanguage]}</span>} */}
  </li>
);

const SortableList = SortableContainer(({
  items,
  selectedLanguage,
  translations,
  panelsDisplay,
  handleSwitch,
  isWebphoneEnabled,
  // themepanel,
  theme
}) => {
  return (
    <ul className={`list-unstyled sortable-list-custom${theme}`} >
     {/* {themepanel === true ? "-dark" : "list-unstyled sortable-list-custom"}> */}
      {items.map((value, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          value={value}
          selectedLanguage={selectedLanguage}
          translations={translations}
          panelsDisplay={panelsDisplay}
          handleSwitch={handleSwitch}
          isWebphoneEnabled={isWebphoneEnabled}
          disabled = {value === 'web_phone' ? true : false }
        />
      ))}
    </ul>
  );
});

class EditPanelModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      showErr: false,
      panels_order: [],
      draggingIndex: null,
      components: {
        web_phone: true,
        chat: true,
        telephony: true,
        calls_in_queue: true,
        agent: true,
        incoming_calls: true,
        autodialer: true,
        outgoing_calls: true,
        // themepanel: true
      },
      isWebphone_enabled: false
    };
  }
  // updates sorting of panels.
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState({
      panels_order: arrayMove(this.state.panels_order, oldIndex, newIndex),
    });
  };
  /** gets panels data from redux store and loops through.
    * if all components related to panels exists then displays them as per sorting.
    * else it renders default sorting of panels
  */

  handleEnter = () => {
    let panels_order, panels_display;
    if (this.props.agentConfig.panels_display) {
      let isValid = true;
      const panels_display_obj = this.isObject(this.props.agentConfig.panels_display) ? this.props.agentConfig.panels_display : {};
      if (Object.keys(panels_display_obj).length > 0) {
        Object.keys(this.props.agentConfig.panels_display).forEach((key, value) => {
          if (!this.state.components[key]) {
            isValid = false;
          }
        });
      } else {
        isValid = false;
      }
      if (isValid) {
        panels_order = { ...this.props.agentConfig.panels_order };
        panels_display = { ...this.props.agentConfig.panels_display };
        panels_order = Object.keys(panels_order).sort(function (a, b) { return panels_order[a] - panels_order[b] });
        // if(panels_display.themepanel === undefined){
        //   const themeobj = {themepanel:false};
        //   const themeorder = "themepanel";
        //   panels_order.push(themeorder);
        //   panels_display = { ...this.props.agentConfig.panels_display, ...themeobj};
        // }
        if (!this.props.agentConfig.panels_display.hasOwnProperty('web_phone')) {
          panels_order.unshift('web_phone')
          panels_display.web_phone =  false
        }
      } else {
        panels_order = ['web_phone', 'telephony', 'calls_in_queue', 'incoming_calls', 'outgoing_calls', 'agent', 'autodialer'];
        panels_display = { web_phone: false, telephony: true, calls_in_queue: true, incoming_calls: true, outgoing_calls: true, chat: false, agent: true, autodialer: true};
        // this.setState({panels_order, panels_display});
      }
    } else {
      panels_order = ['web_phone', 'telephony', 'calls_in_queue', 'incoming_calls', 'outgoing_calls', 'agent', 'autodialer'];
      panels_display = { web_phone: false, telephony: true, calls_in_queue: true, incoming_calls: true, outgoing_calls: true, chat: false, agent: true, autodialer: true};
      // this.setState({panels_order, panels_display});
    }
    panels_order = panels_order.filter(item => item != 'chat');
    panels_display.chat = false;
    this.setState({ panels_order, panels_display });
  }

  isObject = (item) => {
    return (typeof item === "object" && !Array.isArray(item) && item !== null);
  }

  close = (key) => {
    this.setState({
      showErr: false
    }, () => {
      this.props.handleClose(key);
    });

  }
  // handles switch value for panels and updates state
  handleSwitch = (el, state, name) => {
    let panels_display = this.state.panels_display;
    panels_display[name] = !this.state.panels_display[name];
    if((name === 'web_phone') && panels_display.web_phone) {
      this.setState({isWebphone_enabled: true});
      // panels_display[name] = 'required_signin'
    }
    this.setState({
      panels_display
    });
  }

  handleOnPanelsNotUpdated = () => {
    this.setState({
      showErr: true,
      errorMsg:
        this.props.translations.commonErrorText[this.props.selectedLanguage],
    });
  }

  // submits agents configration
  handleSubmit = () => {
    const updateOrder = true;
    const { panels_display, panels_order } = this.state;
    const username = localStorage.getItem("username");

    const duplicate_panels_display = {
      telephony: panels_display.telephony,
      calls_in_queue: panels_display.calls_in_queue,
      incoming_calls: panels_display.incoming_calls,
      outgoing_calls: panels_display.outgoing_calls,
      autodialer: panels_display.autodialer,
      chat: false,
      agent: panels_display.agent,
      web_phone:
        panels_display.web_phone !== undefined
          ? panels_display.web_phone
          : false,
    };

    const duplicate_panels_order = {
      telephony: updateOrder
        ? panels_order.indexOf("telephony") + 1
        : panels_order.telephony,
      calls_in_queue: updateOrder
        ? panels_order.indexOf("calls_in_queue") + 1
        : panels_order.calls_in_queue,
      incoming_calls: updateOrder
        ? panels_order.indexOf("incoming_calls") + 1
        : panels_order.incoming_calls,
      outgoing_calls: updateOrder
        ? panels_order.indexOf("outgoing_calls") + 1
        : panels_order.outgoing_calls,
      autodialer: updateOrder
        ? panels_order.indexOf("autodialer") + 1
        : panels_order.autodialer,
      chat: panels_order.length + 1,
      agent: updateOrder
        ? panels_order.indexOf("agent") + 1
        : panels_order.agent,
      web_phone:
        panels_order.web_phone !== undefined
          ? updateOrder
            ? panels_order.indexOf("web_phone") + 1
            : panels_order.web_phone
          : 1,
    };

    getV2AxiosInstance()
      .patch(`/api/es/invoxapi/userproperties/${username}`, {
        data: {
          apps: {
            webagent: {
              layout: {
                panels_display: duplicate_panels_display,
                panels_order: duplicate_panels_order,
              },
            },
          },
        },
      })
      .then((res) => {
        if (res.data.result) {
          let { agentConfig } = this.props;
          agentConfig.panels_display = duplicate_panels_display;
          agentConfig.panels_order = duplicate_panels_order;
          this.props.handleClose(this.props.showPanelSetupModal);
          this.props.setAgentConfig(JSON.parse(JSON.stringify(agentConfig)));
        } else {
          this.handleOnPanelsNotUpdated();
        }
      })
      .catch((error) => {
        console.log(error);
        this.handleOnPanelsNotUpdated()
      });
  }

  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }

  render() {
    const { translations, selectedLanguage } = this.props;
    return (
      <Modal
        onEnter={this.handleEnter}
        show={this.props.showPanelSetupModal}
        onHide={() => this.close('showPanelSetupModal')}
        dialogClassName="panel_order_modal"
        bsSize="sm"
        backdrop="static"
      >
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.pageLayout[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`} style={{ maxHeight: 450, overflow: 'auto' }}>
          {this.state.showErr && <div className="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          <p>{translations.pageLayoutDescription[selectedLanguage]}</p>
          <SortableList
            items={this.state.panels_order}
            onSortEnd={this.onSortEnd}
            yesText={this.props.translations.yes[this.props.selectedLanguage]}
            noText={this.props.translations.no[this.props.selectedLanguage]}
            panelsDisplay={this.state.panels_display}
            handleSwitch={this.handleSwitch}
            useDragHandle
            helperClass="current_sortable"
            translations={translations}
            selectedLanguage={selectedLanguage}
            isWebphoneEnabled={this.state.isWebphone_enabled}
            // themepanel={this.props.darkMode}
            theme={this.props.theme}
          />
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button type="button" onClick={() => this.close('showPanelSetupModal')} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">{translations.cancel[selectedLanguage]}</button>
          <button type="submit" onClick={this.handleSubmit} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    agentConfig: state.agentConfig,
    agentInfo: state.agentInfo,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
    themecode: state.common.themecode,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setAgentConfigData, setAgentConfig }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPanelModal);



// WEBPACK FOOTER //
// ./src/agent/modals/editPanel.js